import { Dispatch, FC, SetStateAction } from 'react';
import { AssignEsimMode } from '#types';

interface AssignEsimModeRadioButtonsProps {
    assignMode: AssignEsimMode | undefined;
    setAssignMode: Dispatch<SetStateAction<AssignEsimMode | undefined>>;
}

export const AssignEsimModeRadioButtons: FC<AssignEsimModeRadioButtonsProps> = ({ assignMode, setAssignMode }) => {

    return <div className="mb-m">
        <div>
            <label>
                <input
                    type="radio"
                    value="newEsim"
                    className='mr-s notification-radio-button'
                    checked={assignMode === AssignEsimMode.NEW_ESIM}
                    onChange={() => setAssignMode(AssignEsimMode.NEW_ESIM)}
                />
                Assign a new eSIM
            </label>
        </div>
        <div>
            <label>
                <input
                    type="radio"
                    value="stripeOnly"
                    className='mr-s notification-radio-button'
                    checked={assignMode === AssignEsimMode.STRIPE_REPLACE_PLAN}
                    onChange={() => setAssignMode(AssignEsimMode.STRIPE_REPLACE_PLAN)}
                />
                Use Stripe Client Reference ID to replace existing plan
            </label>
        </div>
        <div>
            <label>
                <input
                    type="radio"
                    value="stripeAndPlan"
                    className='mr-s notification-radio-button'
                    checked={assignMode === AssignEsimMode.STRIPE_NEW_PLAN}
                    onChange={() => setAssignMode(AssignEsimMode.STRIPE_NEW_PLAN)}
                />
                Use Stripe Client Reference ID and assign a new plan
            </label>
        </div>
    </div>
}
